import * as React from 'react';

import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import {SwitchName} from './switch-name';

import styles from './setting-toggle.module.css';

interface Props {
    displayName: string;
    isOn: boolean;
    onToggle: () => void;
    isDisabled?: boolean;
    infoLink?: string | null;
    children?: React.ReactNode;
}

export function SettingToggle(props: Props) {
    return (
        <div className='my-8 flex flex-dir-col gap-8'>
            <SwitchName displayName={props.displayName} infoLink={props.infoLink} />
            <div className={styles['switch-container']}>
                <div className='flex justify-sb'>
                    <Switch
                        isDisabled={props.isDisabled}
                        isOn={props.isOn}
                        isRounded={true}
                        onChange={props.onToggle}
                    />
                    <Body>{props.isOn ? 'On' : 'Off'}</Body>
                </div>
            </div>
            {props.children}
        </div>
    );
}
